import React from 'react';
import { CTA, styled } from '@volkswagen-onehub/components-core';

interface Props {
  label: string;
  ariaLabel: string;
  handleClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
};

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ApplyFilters = ({ label, ariaLabel, handleClick, disabled }: Props) => {
  return (
    <StyledButtonWrapper>
      <CTA
        tag="button"
        emphasis="primary"
        onClick={e => handleClick(e)}
        ariaLabel={ariaLabel}
        disabled={disabled}
      >
        { label }
      </CTA>
    </StyledButtonWrapper>
  )
}
